import React, { useEffect, useState, ChangeEvent } from 'react';
import { AxiosResponse, AxiosError } from 'axios';
import { useGetApiRequests, triggerNotification, ErrorMessages } from '../../../common/CommonExport';
import { useSelector } from 'react-redux';
import { initialState } from './EditOrganisationHelper';
import Loader from '../../../components/Loader/Loader';
import EditOrganisationSectionOne from './EditOrganisationSectionOne';
import EditOrganisationSectionTwo from './EditOrganisationSectionTwo';
import EditOrganisationSectionThree from './EditOrganisationSectionThree';
import EditOrganisationSignatures from './EditOrganisationSignatures';
import { convertUrlToFile } from './EditOrgHelper';
import { OrganisationValues, Department, OrganisationParams, ApiHeaders, ReduxState, OrganisationApiResponse, DepartmentListApi } from './types/EditOrganisationTypes';

const EditOrganisation = () => {
    const getHodListApi = useGetApiRequests('getOrganisationDetails', 'GET');
    const organisationEdit = useGetApiRequests('editOrganisation', 'PUT');
    const [loader, setLoader] = useState(false);
    const orgId = useSelector((state: ReduxState) => state?.organisationId?.id);
    const getHodListApi1 = useGetApiRequests('getDepartment', 'GET');
    const [departmentId, setdepartmentId] = useState<string | number>();
    const [employee, setemployee] = useState<Department[]>([]);
    const [values, setValues] = useState<OrganisationValues>(initialState)
    const [imageData, setImageData] = useState<FormData>(new FormData());
    const [selectedImage, setSelectedImage] = useState<string>("");
    const [selectedhrImage, setSelectedhrImage] = useState<string>("");
    const [showError, setShowError] = useState<boolean>(false)
    const [imageDataLogo, setImageDataLogo] = useState<File>();
    const [imageDataSign, setImageDataSign] = useState<File>();
    const [selectedCeoImage, setSelectedCeoImage] = useState<string>("");
    const [selectedCtoImage, setSelectedCtoImage] = useState<string>("");
    const [selectedCooImage, setSelectedCooImage] = useState<string>("");
    const [imageDataCeo, setImageDataCeo] = useState<File>();
    const [imageDataCto, setImageDataCto] = useState<File>();
    const [imageDataCoo, setImageDataCoo] = useState<File>();
    const [selectedItImage, setSelectedItImage] = useState<string>("");
    const [selectedFinanceImage, setSelectedFinanceImage] = useState<string>("");
    const [imageDataIt, setImageDataIt] = useState<File>();
    const [imageDataFinance, setImageDataFinance] = useState<File>();
    useEffect(() => {
        getOrganisationList();
        getDepartmentList();
    }, []);
    const getOrganisationList = () => {
        const params: OrganisationParams = {
            organisationId: orgId,
        };
        setLoader(true)
        getHodListApi('', params)
            .then((res) => {
                const responseData = res as AxiosResponse<OrganisationApiResponse>;
                const data: OrganisationValues = responseData?.data?.data;
                const updatedValues = {
                    name: data?.name,
                    adminEmailId: data?.adminEmailId,
                    accountsEmailId: data?.accountsEmailId,
                    hrDeptId: data?.hrDeptId.toString(),
                    hrName: data?.hrName,
                    hrEmailId: data?.hrEmailId,
                    hrdesignation: data?.hrdesignation,
                    systemVendor: data?.systemVendor,
                    probationPeriodDays: data?.probationPeriodDays.toString(),
                    reviewMonth: data?.reviewMonth.toString(),
                    notifyingPeriod: data?.notifyingPeriod.toString(),
                    isSlackNotification: data?.isSlackNotification,
                    slackCode: data?.slackCode,
                    mobileNumber: data?.mobileNumber,
                    emailId: data?.emailId,
                    latitude: data?.latitude ? data?.latitude : "",
                    longitude: data?.longitude ? data?.longitude : "",
                    radius: data?.radius ? data?.radius : "",
                    permanentAddress: {
                        addressId: data?.permanentAddress.addressId,
                        doorNo: data?.permanentAddress.doorNo,
                        street: data?.permanentAddress.street,
                        city: data?.permanentAddress.city,
                        state: data?.permanentAddress.state,
                        pinCode: data?.permanentAddress.pinCode.toString(),
                        phoneNumber: data?.permanentAddress.phoneNumber,
                    },
                    presentAddress: {
                        addressId: data?.presentAddress.addressId,
                        doorNo: data?.presentAddress.doorNo,
                        street: data?.presentAddress.street,
                        city: data?.presentAddress.city,
                        state: data?.presentAddress.state,
                        pinCode: data?.presentAddress.pinCode.toString(),
                        phoneNumber: data?.presentAddress.phoneNumber,
                    },
                    domainName: data?.domainName,
                    ssoCreateUrl: data?.ssoCreateUrl,
                    ssoDeleteUrl: data?.ssoDeleteUrl,
                    applocation1CreateUrl: data?.applocation1CreateUrl,
                    applocation1DeleteUrl: data?.applocation1DeleteUrl,
                    emailService: data?.emailService,
                    code: data?.code,
                    ceoEmailId: data?.ceoEmailId,
                    ctoEmailId: data?.ctoEmailId,
                    cooEmailId: data?.cooEmailId,
                    groupEmail: data?.groupEmail



                };

                setSelectedImage(data?.logo || "")
                if (data?.logo) convertUrlToFile(data?.logo, "logo").then((file) => file && setImageDataLogo(file));

                setSelectedhrImage(data?.hrSignature || "")
                if (data?.hrSignature) convertUrlToFile(data?.hrSignature, "hrSignature").then((file) => file && setImageDataSign(file));

                setSelectedCeoImage(data?.ceoSignature || "")
                if (data?.ceoSignature) convertUrlToFile(data?.ceoSignature, "ceoSignature").then((file) => file && setImageDataCeo(file));

                setSelectedCtoImage(data?.ctoSignature || "")
                if (data?.ctoSignature) convertUrlToFile(data?.ctoSignature, "ctoSignature").then((file) => file && setImageDataCto(file));

                setSelectedCooImage(data?.cooSignature || "")
                if (data?.cooSignature) convertUrlToFile(data?.cooSignature, "cooSignature").then((file) => file && setImageDataCoo(file));

                setSelectedItImage(data?.itAdminSignature || "")
                if (data?.itAdminSignature) convertUrlToFile(data?.itAdminSignature, "itAdminSignature").then((file) => file && setImageDataIt(file));

                setSelectedFinanceImage(data?.financeAdminSignature || "")
                if (data?.financeAdminSignature) convertUrlToFile(data?.financeAdminSignature, "financeAdminSignature").then((file) => file && setImageDataFinance(file));
                setValues(updatedValues);
                sessionStorage.setItem("hrDeptId", updatedValues.hrDeptId)
                setdepartmentId(updatedValues.hrDeptId)
                setLoader(false)
            })
            .catch((err: AxiosError) => {
                triggerNotification('error', '', ErrorMessages.somethingWentWrong, 'topRight');
                setLoader(false)
            });
    };
    const getDepartmentList = () => {
        const params: OrganisationParams = {
            organisationId: orgId,
        };
        setLoader(true)
        getHodListApi1('', params)
            .then((res) => {
                const response = res as AxiosResponse<DepartmentListApi>;
                const reformedDepartmentList = response?.data?.data.map((item) => ({
                    value: item.departmentId,
                    label: item.name,
                    designation: item.designation,
                }));
                setemployee(reformedDepartmentList);
                setLoader(false)
            })
            .catch((err: AxiosError) => {
                triggerNotification('error', '', ErrorMessages.somethingWentWrong, 'topRight');
                setLoader(false)
            });
    };
    function isValidPinCode(pinCode: string | number | null | undefined) {
        return typeof pinCode === 'string' && pinCode.length === 6;
    }

    function isValidPhoneNumber(phoneNumber: string | number | null | undefined) {
        return typeof phoneNumber === 'string' && phoneNumber.length === 10;
    }

    function checkForEmptyValues(dataArray: Record<string, unknown>[]) {
        const excludedKeys = ['isSlackNotification', 'slackCode', 'mobileNumber', 'ssoDeleteUrl', 'ssoCreateUrl', 'emailService', 'emailId', 'domainName', 'applocation1CreateUrl', 'applocation1DeleteUrl'];
        for (const obj of dataArray) {
            for (const key in obj) {
                if (!excludedKeys.includes(key)) {
                    const value = obj[key];
                    if (typeof value === 'object' && !Array.isArray(value)) {

                        const nestedObj = value as unknown as Record<string, string | number | null | undefined>;
                        for (const nestedKey in nestedObj) {
                            if (nestedKey === 'pinCode' && !isValidPinCode(nestedObj[nestedKey])) {
                                return false;
                            }
                            if (nestedKey === 'phoneNumber' && !isValidPhoneNumber(nestedObj[nestedKey])) {
                                return false;
                            }
                            if (nestedObj[nestedKey] === null || nestedObj[nestedKey] === undefined || nestedObj[nestedKey] === '') {
                                return false;
                            }
                            if (nestedKey === 'latitude' && !isValidPhoneNumber(nestedObj[nestedKey])) {
                                return false;
                            }

                        }
                    } else {
                        if (key === 'pinCode' && !isValidPinCode(value as string | number | null | undefined)) {
                            return false;
                        }
                        if (key === 'phoneNumber' && !isValidPhoneNumber(value as string | number | null | undefined)) {
                            return false;
                        }
                        if (value === null || value === undefined || value === '') {
                            return false;
                        }
                    }
                }
            }
        }
        return true;
    }
    const isObjectEmpty = (obj: OrganisationValues) => {
        const dataArray = Object.keys(obj).map(key => ({ [key]: obj[key] }));
        const result = checkForEmptyValues(dataArray);
        return result
    }
    const handelSubmit = () => {
        const trimmedValues = {
            ...values,

            adminEmailId: (values?.adminEmailId || "").trim(),
            hrEmailId: (values?.hrEmailId || "").trim(),
            ceoEmailId: (values?.ceoEmailId || "").trim(),
            cooEmailId: (values?.cooEmailId || "").trim(),
            ctoEmailId: (values?.ctoEmailId || "").trim(),
            accountsEmailId: (values?.accountsEmailId || "").trim(),
            systemVendor: (values?.systemVendor || "").trim(),


        };


        let isFormValid = isObjectEmpty(trimmedValues);
        const pathParams: object = { id: orgId, };
        trimmedValues['organisationId'] = orgId
        const query: object = { organisationDto: trimmedValues, };
        const headers = { 'Content-Type': 'multipart/form-data', };
        const formData = new FormData();

        if (imageDataLogo) {
            formData.append('organisationLogo', imageDataLogo);

        }
        if (imageDataSign) {
            formData.append('hrSignature', imageDataSign);

        }
        if (imageDataCeo) {
            formData.append('ceoSignature', imageDataCeo);

        }
        if (imageDataCto) {
            formData.append('ctoSignature', imageDataCto);

        }
        if (imageDataCoo) {
            formData.append('cooSignature', imageDataCoo);

        }
        if (imageDataIt) {
            formData.append('itAdminSignature', imageDataIt);

        }
        if (imageDataFinance) {
            formData.append('financeAdminSignature', imageDataFinance);
        }
        if (isFormValid) {
            setShowError(false)
            handleApiCall(formData, query, pathParams, ErrorMessages.organisationUpdation, ErrorMessages.somethingWentWrong, headers);
        }
        else {
            setShowError(true)
        }
    };
    const handleApiCall = async (imageData: FormData, query: object, pathParams: object, successMessage: string, errorMessage: string, headers: ApiHeaders) => {
        setLoader(true)
        try {
            await organisationEdit(imageData, query, pathParams, headers);
            triggerNotification('success', '', successMessage, 'topRight');
            setLoader(false)
        } catch (err) {
            triggerNotification('error', '', errorMessage, 'topRight');
            setLoader(false)
        }
    };
    const handleChange = (value: string, field: string) => {
        const emailFields = ["hrEmailId", "ceoEmailId", "cooEmailId", "ctoEmailId", "accountsEmailId", "adminEmailId", "systemVendor"];

        const cleanedValue =
            (emailFields.includes(field) && typeof value === "string")
                ? value.trim()
                : value;

        const updateValues = { ...values };

        if (field === 'doorNo' || field === 'street' || field === 'city' || field === 'state' || field === 'pinCode' || field === 'phoneNumber') {
            updateValues.presentAddress = {
                ...updateValues.presentAddress,
                [field]: cleanedValue,
            };
        } else if (field === 'doorNoPermanent' || field === 'streetPermanent' || field === 'cityPermanent' || field === 'statePermanent' || field === 'pinCodePermanent' || field === 'phoneNumberPermanent') {
            updateValues.permanentAddress = {
                ...updateValues.permanentAddress,
                [field.replace('Permanent', '')]: cleanedValue,
            };
        }
        else {
            updateValues[field] = cleanedValue;
        }
        if (field === "hrDeptId") {
            setdepartmentId(value)
            updateValues['hrName'] = ''
        }
        setValues(updateValues);
    }
    const handleImageUpload = (event: ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            const formData = new FormData();
            formData.append('organisationLogo', file);
            setImageData(formData);
            setImageDataLogo(file)
            setSelectedImage(URL.createObjectURL(file));
        }
    };
    const handlehrImage = (event: ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            const formData = new FormData();
            formData.append('hrSignature', file);
            setImageData(formData);
            setImageDataSign(file)
            setSelectedhrImage(URL.createObjectURL(file));
        }
    };
    const handleCeoImage = (event: ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];

        setImageDataCeo(file)
        if (file) {
            setSelectedCeoImage(URL.createObjectURL(file));
        }
    };
    const handleCtoImage = (event: ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        setImageDataCto(file)
        if (file) {
            setSelectedCtoImage(URL.createObjectURL(file));
        }
    };
    const handleCooImage = (event: ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        setImageDataCoo(file)
        if (file) {
            setSelectedCooImage(URL.createObjectURL(file));
        }
    };
    const handleItImage = (event: ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        setImageDataIt(file)
        if (file) {
            setSelectedItImage(URL.createObjectURL(file));
        }
    };
    const handleFinanceImage = (event: ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        setImageDataFinance(file)
        if (file) {
            setSelectedFinanceImage(URL.createObjectURL(file));
        }
    };
    return (
        <>
            {loader && <Loader />}
            <div className='w-full flex'>
                <div className='w-9/12'>
                    <EditOrganisationSectionOne values={values} handleChange={handleChange} employee={employee}
                        getOrganisationList={getOrganisationList} getDepartmentList={getDepartmentList} showError={showError} />
                    <EditOrganisationSignatures
                        selectedhrImage={selectedhrImage} handlehrImage={handlehrImage}
                        selectedCeoImage={selectedCeoImage} handleCeoImage={handleCeoImage}
                        selectedCtoImage={selectedCtoImage} handleCtoImage={handleCtoImage}
                        selectedCooImage={selectedCooImage} handleCooImage={handleCooImage}
                        selectedItImage={selectedItImage} handleItImage={handleItImage}
                        selectedFinanceImage={selectedFinanceImage} handleFinanceImage={handleFinanceImage}
                    />
                </div>
                <div className='w-1/4' style={{ width: '25%' }}>
                    <EditOrganisationSectionTwo selectedImage={selectedImage} handleImageUpload={handleImageUpload} />
                </div>
            </div>
            <div className='edit-organisation_address'>
                <EditOrganisationSectionThree values={values} handleChange={handleChange} employee={employee} showError={showError} />
            </div>
            <div className='mt-5'>
                <button className='addButton mr-4  ' onClick={() => handelSubmit()}  >
                    Save
                </button>
            </div>
        </>
    );
};

export default EditOrganisation;
